import React,{Component}from 'react';
import {BrowserRouter as Router, Route}from 'react-router-dom'
// import logo from './logo.svg';
import './App.css';
import Todos from './Todos.js'
import About from './About.js'
import AddTodo from './AddTodo.js';
import Header from './Header';
// import Form from './Form.js'
// import uuid from 'uuid'
import axios from 'axios'



class App extends Component {

  state={
      title: '',
      
     todos: [] 
    
      // { id:uuid.v4(),
      //   task:'i will see a doctor',
      //   completed: true
      // },
      // { id:uuid.v4(),
      //   task:'wifey duties',
      //   completed:false
      // },
      // {id:uuid.v4(),
      //   task:'children duties',
      //   completed:true,
      // }
    
  }


  componentDidMount(){
    axios.get('https://jsonplaceholder.typicode.com/todos?_limit=10')
    .then (res => this.setState({todos:res.data}))
  }

// Toggle Change
toggleHandler = (id)=>{
  this.setState({todos:this.state.todos.map(todo => {
    if(todo.id === id){
      todo.completed =!todo.completed
    }
    return todo;
  }) })
}

// // delete Todo
// deleteTodo = (id)=>{
//   this.setState({todos: [...this.state.todos.filter(todo => todo.id !== id)]});
// }

// delete Todo from the backend server 
deleteTodo = (id)=>{
  axios.delete(`https://jsonplaceholder.typicode.com/todos/${id}`)
  .then(res => this.setState({todos: [...this.state.todos.filter(todo => todo.id !== id)] }))
  ;
}



//  AddTodo to the user interface
//  addTodo=(title)=>{
//    const newTodo = {
//      id:uuid.v4(),
//     title:title,
//      completed:false
//    }
//    this.setState({ todos: [...this.state.todos, newTodo] });
//  }


//  AddTodo ,making a post request to your backend server
//  
 addTodo=(title)=>{
   axios.post('https://jsonplaceholder.typicode.com/todos', {
     title,
     completed:false
   })
   .then(res => this.setState({todos:[...this.state.todos, res.data]}))

   
 }
render(){
  

  return (
    <Router>
       <div className="App">
         <Header />
      <Route exact path="/" render={props =>(
      <React.Fragment>
          <AddTodo addTodo={this.addTodo} />
          <Todos todos={this.state.todos}  deltodo={this.deleteTodo} ontoggle={this.toggleHandler}/> 
      </React.Fragment>
      )} /> 

  <Route path ="/about" component ={About} />


   </div>
    </Router>
  );
}
}
export default App;


